import * as React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { Suggestion } from '@fluentui-copilot/react-suggestions';
import { useMCAPSCopilotTelemetry } from './utils/mcapsCopilotTelemetry';


import type { FollowUpQuestion, FollowUpQuestionsProps } from './interfaces';

const useStyles = makeStyles({
  followUpContainer: {
    padding: '12px',
    backgroundColor: '#f3f2f1',
    '& .followup-questions-wrapper': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end', 
      gap: '8px'
    },
    '& .followup-suggestion': {
      display: 'inline-block', 
      padding: '4px 8px',     
      
      borderRadius: '8px', 
      border: `1px solid #b4d6fa`,
      cursor: 'pointer',
      fontSize: '12px',
      maxWidth: 'fit-content', 
      textAlign: 'left',
      transition: 'all 0.2s ease',  
      lineHeight:'16px',
      fontWeight:'400'
    }
  }
});

const FollowUpQuestions: React.FC<FollowUpQuestionsProps> = ({ 
  followUpQuestions, 
  handlePromptSelected,
  dispatch
}) => {
  const styles = useStyles();
  const telemetry = useMCAPSCopilotTelemetry(dispatch);

  if (!followUpQuestions || followUpQuestions.length === 0) {
    return null;
  }

  return (
    <div className={styles.followUpContainer}>
      <div className="followup-questions-wrapper" role="list">
        {followUpQuestions.map((fq, i) => (
          <Suggestion            
            key={i}
            onClick={() => {
              
              telemetry.logFollowUpClicked({
                query: fq.question,
                action: 'click',
                component: 'FollowUpQuestion'
              });
              handlePromptSelected(fq.question);
            }}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                
                telemetry.logFollowUpClicked({
                  query: fq.question,
                  action: 'click',
                  component: 'FollowUpQuestion'
                });
                handlePromptSelected(fq.question);
              }
            }}
            className="followup-suggestion"
            data-index={i}
          >
            {fq.question}
          </Suggestion>
        ))}
      </div>
    </div>
  );
};

export default FollowUpQuestions;